import {api2} from "./api-config-localhost";
import {AxiosResponse} from "axios";

export const getJsonServer = (endpoint: string, addTotal: boolean = false) => handle(
    api2.get(endpoint),
    addTotal
)

export const postJsonServer = (endpoint: string, data: any = null) => handle(
    api2.post(endpoint, data)
)

export const putJsonServer = (endpoint: string, data: any = null) => handle(
    api2.put(endpoint, data)
)

async function handle(axiosQuery: Promise<AxiosResponse>, addTotal: boolean = false) {
    const response = await axiosQuery;

    if (addTotal) {
        return {
            total: response.headers["x-total-count"],
            data: response.data
        }
    }

    return response.data;
}
